import React from 'react';
import { ShieldCheck, Truck, RotateCcw } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// Bölmənin mətnləri — LanguageContext-də açarı olmayanlar burada saxlanılır
const TEXT = {
  eyebrow: {
    az: 'XİDMƏT',
    en: 'SERVICE',
    ru: 'СЕРВИС',
    tr: 'HİZMET',
  },
  heading: {
    az: 'Alış-verişiniz rahat olsun deyə',
    en: 'So your shopping stays effortless',
    ru: 'Чтобы покупки были лёгкими',
    tr: 'Alışverişiniz kolay olsun diye',
  },
};

const ITEMS = [
  {
    id: 'quality',
    icon: ShieldCheck,
    title: {
      az: 'Keyfiyyət zəmanəti',
      en: 'Quality guarantee',
      ru: 'Гарантия качества',
      tr: 'Kalite garantisi',
    },
    text: {
      az: 'Yalnız premium materiallar və İtalyan parçaları',
      en: 'Premium materials and Italian fabrics only',
      ru: 'Только премиальные материалы и итальянские ткани',
      tr: 'Yalnızca premium malzemeler ve İtalyan kumaşları',
    },
  },
  {
    id: 'delivery',
    icon: Truck,
    title: {
      az: 'Sürətli çatdırılma',
      en: 'Fast delivery',
      ru: 'Быстрая доставка',
      tr: 'Hızlı teslimat',
    },
    text: {
      az: 'Bakı üzrə 24 saat, regionlara 2–3 gün',
      en: '24 hours in Baku, 2–3 days to the regions',
      ru: '24 часа по Баку, 2–3 дня в регионы',
      tr: 'Bakü içi 24 saat, bölgelere 2–3 gün',
    },
  },
  {
    id: 'returns',
    icon: RotateCcw,
    title: {
      az: 'Pulsuz qaytarma',
      en: 'Free returns',
      ru: 'Бесплатный возврат',
      tr: 'Ücretsiz iade',
    },
    text: {
      az: '7 gün ərzində qaytarma və dəyişdirmə',
      en: 'Returns and exchanges within 7 days',
      ru: 'Возврат и обмен в течение 7 дней',
      tr: '7 gün içinde iade ve değişim',
    },
  },
];

const Features = () => {
  const { language } = useLanguage();
  const tx = (obj) => obj[language] || obj.az;

  return (
    <section className="border-t border-gray-100 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 py-16 sm:py-20 lg:py-24">
        {/* Başlıq */}
        <div className="mb-12 sm:mb-16">
          <p className="text-[11px] tracking-[0.25em] text-gray-400 mb-3">
            {tx(TEXT.eyebrow)}
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif text-gray-900 max-w-xl leading-snug">
            {tx(TEXT.heading)}
          </h2>
        </div>

        {/* Üç sütun — incə ayırıcı xətlərlə */}
        <div className="grid grid-cols-1 sm:grid-cols-3 sm:divide-x divide-gray-100">
          {ITEMS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={item.id}
                className={`py-8 sm:py-0 sm:px-8 first:sm:pl-0 last:sm:pr-0 ${
                  idx !== ITEMS.length - 1 ? 'border-b sm:border-b-0 border-gray-100' : ''
                }`}
              >
                <Icon className="w-5 h-5 text-gray-900 mb-5" strokeWidth={1.25} />
                <h3 className="text-sm font-medium tracking-wide text-gray-900 mb-2">
                  {tx(item.title)}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed max-w-xs">
                  {tx(item.text)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
